import { useEffect, useState } from "react";

export const useNetworkStatus = () => {
	const [isOnline, setIsOnline] = useState(navigator.onLine);
	const [isOffline, setIsOffline] = useState(!navigator.onLine);

	useEffect(() => {
		const updateOnlineStatus = () => {
			setIsOnline(true);
			setIsOffline(false);
		};
		const updateOfflineStatus = () => {
			setIsOnline(false);
			setIsOffline(true);
		};

		globalThis.addEventListener("online", updateOnlineStatus);
		globalThis.addEventListener("offline", updateOfflineStatus);

		return () => {
			globalThis.removeEventListener("online", updateOnlineStatus);
			globalThis.removeEventListener("offline", updateOfflineStatus);
		};
	}, []);

	return { isOnline, isOffline };
};
